import { Injectable, NgZone } from '@angular/core';
import { Observable, ReplaySubject, race, timer, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

declare var turnstile: any;

@Injectable({
  providedIn: 'root'
})
export class CloudflareTurnstileService {
  private widgetId: any;
  private tokenSubject = new ReplaySubject<string>(1);
  private TIMEOUT_MS = 10000;

  constructor(private zone: NgZone) {}

  init(container: HTMLElement, siteKey: string) {
    this.widgetId = turnstile.render(container, {
      sitekey: siteKey,
      size: 'invisible',
      execution: 'execute',
      callback: (token: string) => {
        this.zone.run(() => {
          this.tokenSubject.next(token);
        });
      },
      'error-callback': (err: any) => {
        this.zone.run(() => {
          this.tokenSubject.error(err);
        });
      }
    });
  }

  execute(): Observable<string> {
    if (!this.widgetId) {
      throw new Error('Turnstile not initialized');
    }

    this.tokenSubject = new ReplaySubject<string>(1);

    setTimeout(() => {
      turnstile.execute(this.widgetId);
    }, 0);

    const timeout$ = timer(this.TIMEOUT_MS).pipe(
      switchMap(() => throwError(() => new Error('CAPTCHA_TIMEOUT')))
    );

    return race(this.tokenSubject.asObservable(), timeout$);
  }

  reset() {
    if (this.widgetId) {
      turnstile.reset(this.widgetId);
    }
  }

  destroy() {
    if (this.widgetId) {
      turnstile.remove(this.widgetId);
      this.widgetId = null;
    }
  }
}
